module.exports = __webpack_public_path__ + "img/children-icon.b5fa7899.svg";